<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="value"
        :label="label ? label:'Seleccione una fecha'"
        prepend-inner-icon="event"
        :error-messages="error"
        readonly
        filled
        v-on="on"
      />
    </template>
    <v-date-picker
      ref="picker"
      v-model="value"
      :min="today ? $Datetime.now().toISODate() : $Datetime.now().minus({ years: 90 }).toISODate()"
      :max="today ? $Datetime.now().plus({ years: 1.5 }).toISODate() : $Datetime.now().toISODate()"
      @change="_doSave"
    />
  </v-menu>
</template>
<script>
export default {
  name: "DatePicker",
  props: {
    value: String,
    label: String,
    error: String,
    today: Boolean,
  },
  data() {
    return {
      menu: false,
    };
  },
  watch: {
    menu(val) {
      if (this.value) {
      } else {
        val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
      }
    },
  },
  methods: {
    _doSave(date) {
      this.$refs.menu.save(date);
      this.$emit("input", date);
      this.$emit("blur", date);
    },
  },
};
</script>